import '.i{display:flex;}.ssr-plugin'
import '.r{flex-direction:column;}.ssr-plugin'
import { PageLayout } from '../layout/PageLayout'
import { Button } from '@app/components/core/button/Button'
import { ColumnsSection } from '@app/components/blocks/contentSection/ColumnsSection'
import useMediaQuery from '@app/util/useMediaQuery'
import { Text } from '@app/components/core/typography/Text'
import contactUsImage from '@app/assets/images/newsletter-illustration.png'
import { styled } from 'inlines'
import { useAuthModal } from '@app/util/hooks/useAuthModal'
import { useTranslations } from '@i18n/useLanguage'

export const ContactUs = () => {
  const isMobile = useMediaQuery()
  const { showAuthModal } = useAuthModal()
  const translations = useTranslations().app.common
  return (
    <PageLayout>
      <ColumnsSection
        style={{
          gap: isMobile ? '2.5rem' : '4rem',
        }}
        columns={[
          {
            style: {
              alignItems: 'flex-start',
            },
            markdown: `## Contact
Heb je een vraag en vind je het antwoord niet terug in onze [Kennishub](https://crowdbuilding.com/kennishub)? Neem contact op via [support@crowdbuilding.com](mailto:support@crowdbuilding.com).\n
**Ons kantoor:**  
Asterweg 20C-2  
1031 HN Amsterdam\n
`,
            content: (
              <Button
                onClick={() =>
                  (window.location.href = 'mailto:support@crowdbuilding.com')
                }
                label="Email ons"
              />
            ),
          },
          {
            markdown: `## Pers en media
We werken graag samen met de media om de collectieve zelfbouw-beweging onder de aandacht te brengen. Ook voor thema's zoals de wooncrisis, woningmarkt, duurzaam bouwen, en steward-ownership kun je contact met ons opnemen via [communicatie@crowdbuilding.com](mailto:communicatie@crowdbuilding.com).\n
Meer informatie over onze missie en manier van werken vind je op de '[Over ons](https://crowdbuilding.com/about-us)'-pagina. Tekst en beeldmateriaal over CrowdBuilding is beschikbaar in onze persmap.
`,
          },
        ]}
      />

      <ColumnsSection
        style={{
          gap: isMobile ? '2.5rem' : '4rem',
        }}
        columns={[
          {
            markdown: `## Blijf op de hoogte!\n
Blijf op de hoogte van nieuwe projecten en ander nieuws.`,
            content: (
              <div className="i r">
                <Text.Small>
                  We mailen je alleen als we relevant nieuws hebben.
                </Text.Small>
                <Button
                  style={{ marginTop: '2rem', alignSelf: 'flex-start' }}
                  onClick={() => {
                    showAuthModal('signUp')
                  }}
                  label={translations.signUp}
                />
              </div>
            ),
          },
          {
            style: {
              paddingRight: isMobile ? 0 : '4rem',
            },
            imageSrc: contactUsImage,
            imageAlt: 'Contact us illustration',
          },
        ]}
      />
    </PageLayout>
  )
}
